// API配置参数
export const API_CONFIG = {
    apiToken: 'NrhxpCZtXLkPPnDF9527',
    companyId: 1310,
    baseUrl: 'https://mvs-test.edaoduo.com'
    // baseUrl: 'http://127.0.0.1:8080'
}